// extracted by mini-css-extract-plugin
module.exports = {"p0Child":"ChangeTab_p0Child__1T8jt","buttonMargin":"ChangeTab_buttonMargin__IVszX"};